import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('@@TAP/loader');
export const showLoader = actionCreator('SHOW_LOADER');
export const hideLoader = actionCreator('HIDE_LOADER');
//# sourceMappingURL=loader.actions.js.map